//use strict;
export default { 
  namespaced: true,
  namespace: "conferenciaStore",

  state: {
    storename: "conferenciaStore",
    primarykey: "key",
    lastean: "",
    list: [],
    exists: false,
    checklist: [],
    notify: {
      status: 0,
      tipo: "",
      message: "",
      variant: "",
      value: false
    },
  },

  getters: {
    primarykeyGet: (state) => (state.primarykey),
    lasteanGet: (state) => (state.lastean),
    listGet: (state) => (state.list),
    existsGet: (state) => (state.exists),
    checklistGet: (state) => (state.checklist),
    notifyGet: (state) => (state.notify),
    
    listcountGet: (state) => (state.notify),
    checklistcountGet: (state) => (state.notify),
    
    matchedperc: (state) => ((state.checklist.length * 100) / state.list.length).toFixed(2),
    
    listColeted: (state, getters) => {
      return getters.listGet.filter((l) => getters.checklistGet.some(c => c[getters.primarykeyGet] == l[getters.primarykeyGet])).map(g => {
        const { _rowVariant, ...newlist } = g;
        return newlist;
      })
    },
    
    listAssigned: (state, getters) => (getters.listGet.length > 0 ? true : false),
  },
  
  mutations: {
    primarykeySet: (state, value) => { state.primarykey = value },
    lasteanSet: (state, value) => { state.lastean = value },
    existsSet: (state, value) => { state.exists = value },
    notifySet: (state, value) => { state.notify = value },
    
    listSet: (state, value) => { state.list = value },
    listClear: (state) => { state.list = [] },
    
    checklistSet: (state, value) => { state.checklist = value },
    checklistClear: (state) => { state.checklist = [] },
    
    Update: (state, item) => {
      if (typeof (item) == "string") {
        item = { [state.primarykey]: item }
      };

      // console.log("conferenciaJS.Update: ", item);
      
      const check = state.checklist.find((f) => f[state.primarykey] == item[state.primarykey])
      let list = null
      if (state.list.length > 0) { 
        list = state.list.find((f) => f[state.primarykey] == item[state.primarykey])
        if (list) list._match = item._match
      } else {
        list = { _match: true }
      }

      // console.log("Update:item", item)
      
      // iguala os dois arrais...
      if (check) {
        // console.log("Update:check", check)
        if (item._match) { 
          // console.log("Update:item.match", item.match)
          check._match = item._match
        } else {
          const index = state.checklist.findIndex((f) => f[state.primarykey] == item[state.primarykey])
          if (index > -1) {
            // console.log("Update:index", index)
            state.checklist.splice(index, 1)
            state.notify = { status: 200, tipo: "coletadel", message: "Removido com sucesso", variant: "success", value: true }
          }
        }
      } else {
        if (list) {
          // console.log("Update:list", list)
          //console.log("item.match === null", item.hasOwnProperty("match"))
          if (item._match) {
            // console.log("Update:item.match", item.match)
            state.checklist.push({ [state.primarykey]: item[state.primarykey], _match: item._match })
            state.notify = { status: 200, tipo: "coletaadd", message: "Adicionado com sucesso", variant: "success", value: true }
          }
        } else {
          // console.log("Update:não existe")
          state.notify = { status: 404, tipo: "coletafail", message: "Registro coletado não existe", variant: "danger", value: false }
        }
      }
    }
  },

  actions: {
    primarykeySet({ commit }, value) { commit('primarykeySet', value) },
    listSet({ commit }, value) {
      commit('listSet', value.map((l) => {
        if (!l.hasOwnProperty('_match')) {
        l._match = false
        }
        return l;
    })) },
  
    Update({ commit }, item) {
      commit('Update', item)
    },
  }
}